import eventHub from '@services/EventHub'

const EventHub = {
  install (Vue) {
    Vue.prototype.$eventHub = eventHub

    Vue.prototype.$sendSystemEvent = function (event, data) {
      this.$eventHub.$emit(event, data)
      return this
    }

    Vue.prototype.$listenSystemEvent = function (event, callback) {
      this.$eventHub.$on(event, callback)
      return this
    }

    Vue.prototype.$ignoreSystemEvent = function (event, callback) {
      this.$eventHub.$off(event, callback)
      return this
    }
  }
}

export default EventHub



// WEBPACK FOOTER //
// ./src/plugins/EventHub.js